import Reactm,{useEffect} from 'react';
import '../Styles/section.css';
import Aos from "aos";
import "aos/dist/aos.css";

const Section1 = () => {
    useEffect(() => {
        Aos.init({ duration: 100 });
      }, []);
    return (
        <div className="parent">
            <h2 data-aos="fade-up" data-aos-duration="2000">Studio Of African Wildlife Art</h2>
        </div>
    )
}

export default Section1;